/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as actiontypes from './actiontypes';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import {
  singleAccRecQtrData,
  quarterValue,
} from '../../ARSummaryByQtr/store/actions';
import { clearReqAccRecSearchPageDispatch } from '../../ReqAccReceivable/store/actions';
import {
  commonSearchPageOther,
  commonSearchPage,
} from '../../AccountsRevConstants';

export const arSummaryQtrAllData = (val) => {
  return { type: actiontypes.AR_SUMMARY_QTR_ALL_TABLE, payload: val };
};
export const unallocatedBalanceQtrData = (data) => ({
  type: actiontypes.AR_SUMMARY_UNALLOCATED_QTR_TABLE,
  getUnallocatedBlnQtrList: data,
});
export const allAccRecQtrData = (data) => ({
  type: actiontypes.AR_SUMMARY_ALL_QTR_TABLE,
  getAllAccRecQtrList: data,
});
export const quarterAllValue = (data) => ({
  type: actiontypes.AR_SUMMARY_ALL_QTR_VALUE,
  getAllQuarterValue: data,
});
export const selectedRebateList = (val) => {
  return { type: actiontypes.ACC_REBATE_LIST, payload: val };
};
export const arSummartyByQTRFieldAll = (val) => {
  return { type: actiontypes.ALL_FLD_DATA, payload: val };
};
export const selectedRebateName = (val) => {
  return { type: actiontypes.ACC_REBATE_PGM_NAME, payload: val };
};
export const getUnallocatedBalanceQtr = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_UNALLOCATED_BALANCE_QTR}`, val)
    .then((response) => {
      dispatch(unallocatedBalanceQtrData(response.data));
    })
    .catch(() => {
      dispatch(unallocatedBalanceQtrData([]));
    });
};
export const getSingleAccRecQtr = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_QTR_SINGLE}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.AR_SMRY_FOR_QTR_SINGLE,
        payload: response.data,
      });
      if (val.rebateProgram === 'All') {
        dispatch(allAccRecQtrData(response.data));
        dispatch(quarterAllValue(val.quarter));
      } else {
        dispatch(singleAccRecQtrData(response.data));
        dispatch(quarterValue(val.quarter));
      }
    })
    .catch(() => {
      dispatch(singleAccRecQtrData([]));
      dispatch(allAccRecQtrData([]));
      dispatch({
        type: actiontypes.AR_SMRY_FOR_QTR_SINGLE,
        payload: null,
      });
    });
};

export const dispatchClearARSummaryByQtrAllData = (val) => {
  return {
    type: actiontypes.AR_SUMMERY_QTR_ALL_FIELD_CLEAR_REDUX,
    payload: val,
  };
};

export const clearARSummaryByQtrAllPage = () => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.AccountRecReducer;
  const reduxObj1 = getState()?.sharedState?.ArSummaryQtrAllReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let changePass = false;
  let nObj1 = {};
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    const nObj = _.cloneDeep(reduxObj1);
    if (
      updateTabs.filter(
        (x) =>
          x.navTo === '/reqAccReceivable' || x.navTo === '/QtrAccountsRecAll'
      ).length === 0
    ) {
      nObj1 = {
        ...newObj,
        rebate_list: [],
        rebate_pgm: 'MDFD',
        qtr_opt: 'All',
        end_qtr: '',
        start_qtr: '',
        ar_smry_qtr: null,
      };
      changePass = true;
    }
    if (
      updateTabs.filter((x) => x.navTo === '/AccRecNDCDetailAll').length !== 0
    ) {
      newObj1.getAllQuarterValue = nObj.getAllQuarterValue;
    } else if (
      updateTabs.filter((x) => x.navTo === '/QtrAccountsRecAll').length !== 0
    ) {
      newObj1.ar_smry_all_qtr = nObj.ar_smry_all_qtr;
      newObj1.getAllQuarterValue = nObj.getAllQuarterValue;
    } else {
      newObj1 = {};
    }
  } else {
    _.mapKeys({ ...commonSearchPageOther, ...commonSearchPage }, (val, key) => {
      nObj1[key] = val;
    });
    newObj1 = {};
    changePass = true;
  }
  if (changePass) {
    dispatch(clearReqAccRecSearchPageDispatch(nObj1));
  }
  dispatch(dispatchClearARSummaryByQtrAllData(newObj1));
};
